module.exports = __webpack_public_path__ + "static/media/icon4.1a54044a.png";